import { render, staticRenderFns } from "./StepImage.vue?vue&type=template&id=b0932d9c&scoped=true"
import script from "./StepImage.vue?vue&type=script&lang=js"
export * from "./StepImage.vue?vue&type=script&lang=js"
import style0 from "./StepImage.vue?vue&type=style&index=0&id=b0932d9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0932d9c",
  null
  
)

export default component.exports